import { Contact } from "../components/Contact";

export function ContactPage() {
  return <Contact />;
}
